import { DataTable } from "@/components";
import { Button } from "@/components/ui";
import { PdcData } from "@/services";
import { Plus } from "lucide-react";
import { FC } from "react";
import AddEditPayment from "./AddEdit/AddEditPayment";
import usePaymentTracking from "./usePaymentTracking";
import { RootState } from "@/redux/store";
import { useSelector } from "react-redux";
import { LOGIN_ROLES } from "@/lib/utils";

interface PaymetTrackingTableProps {
  data: PdcData[];
  isLoading?: boolean;
  onAddNew?: () => void;
  onPdcCheck?: (checked: boolean) => void;
  isPdcCheckEnabled?: boolean;
  installmentId: string;
  onPdcUpdate?: () => void;
}

const PaymetTrackingTable: FC<PaymetTrackingTableProps> = ({
  data,
  isLoading = false,
  onAddNew,
  onPdcCheck,
  isPdcCheckEnabled = false,
  installmentId,
  onPdcUpdate,
}) => {

  const {
    paymentData,
    columns,
    handleAddNew,
    isFormOpen,
    handleFormClose,
    editingPdc,
  } = usePaymentTracking();
  const loggedInUserData = useSelector(
      (state: RootState) => state.currentData.loggedInUserData
    );
  
    // 👇 backend sends role as array, e.g. ["CRM_HEAD"]
    const roles = loggedInUserData?.role || [];
  
    // Helper to check if user has a given role
    const hasRole = (role: string) => Array.isArray(roles) && roles.includes(role);

  if (isLoading) {
    return (
      <div className="bg-white rounded-lg p-6 shadow-sm">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-lg text-primary">Payment Tracking</h2>
          <div className="flex items-center space-x-2">
           {(hasRole(LOGIN_ROLES.FINANCE_TEAM) || hasRole(LOGIN_ROLES.SUPER_ADMIN)) && (
             <Button type="button" className="bg-primary text-white" disabled>
               <Plus className="w-4 h-4 mr-2" />
               Add New
             </Button>
           )}
          </div>
        </div>
        <div className="animate-pulse">
          <div className="h-4 bg-gray-200 rounded w-3/4 mb-4"></div>
          <div className="space-y-3">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="h-12 bg-gray-200 rounded"></div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg p-6 shadow-sm">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-lg text-primary">Payment Tracking</h2>
        <div className="flex items-center space-x-2">
          {(hasRole(LOGIN_ROLES.FINANCE_TEAM) || hasRole(LOGIN_ROLES.SUPER_ADMIN)) && (
            <Button
              type="button"
              className="bg-primary text-white"
              onClick={handleAddNew}
            >
              <Plus className="w-4 h-4 mr-2" />
            Add New
          </Button>)}
        </div>
      </div>

      <DataTable columns={columns} data={paymentData} />
      <AddEditPayment
        onCancel={handleFormClose}
        open={isFormOpen}
        editData={editingPdc}
      />
    </div>
  );
};

export default PaymetTrackingTable;
